export default {
    sponsorList: [],
    sponsorListCount: 0
}